import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components';
import MachinesAddEditForm from './machine-add-edit-form';
import CustomPropTypes from 'Core/prop-types';
import { addMachine, editMachine } from './store/slice';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import { all_routes } from '../../router/all_routes';

const saveKeys = [
    "changed",
    "id",
    "isDeleted",
    "userId",
]

const editKeys = [
  "changed",
  "isDeleted",
]
const MachinesAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('MachinesAddEdit -> modalData', modalData);

  const machinesData = modalData;
  const [formData, setFormData] = useState(machinesData || null);
  const [partsData, setPartsData] = useState(machinesData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(machinesData?.machinesPickTickets || []);
  const [filesData, setFilesData] = useState(machinesData?.shippingDocuments || []);

  const dispatch = useDispatch();
  const isEditMode = Boolean(machinesData?.id);

  const onChangesMachinesForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <MachinesAddEditForm data={formData} onChanges={onChangesMachinesForm} />
      </div>
    );
  };

  const valid = () => {

    const ignoreKeys = isEditMode ? editKeys : saveKeys;
        if (!formData || Object.keys(formData).some((key) => {
          console.log(key, !ignoreKeys.includes(key), !formData[key],'isEditMode : '+isEditMode)
          return !ignoreKeys.includes(key) && !formData[key]
        })) {
          dispatch(
            showToast({
              message: 'Please fill all required fields',
              type: 'danger',
            }),
          );
          return false;
        }
        return true;
  };

  const footer = () => {
    const onSave = () => {
      if (valid()) {
        const payload = {
          ...formData,
          userId: localStorage.getItem('UserId')
        };
        if (isEditMode) {
          dispatch(editMachine(payload));
        } else {
          dispatch(addMachine(payload));
        }
      }
    };

    return (
      <div className="row">
        <div className="col-12 col-lg-8"></div>
        <div className="col-12 col-lg-4">
          <FooterButton
            cancelText="Cancel"
            saveText="Save Machine"
            onSave={onSave}
            onCancel={handleClose}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal
      id="machines-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Edit Machines' : 'Add Machines'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

MachinesAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(MachinesAddEdit);

